import Geocoder from '@innovyze/stylovyze/lib/utils/geocoder';
import { useSiteConfig } from '@innovyze/stylovyze/lib/contexts';
import { useState } from 'react';
export const useGeocoder = () => {
    const [address, setAddress] = useState();
    const { config } = useSiteConfig();
    const geocoder = new Geocoder({
        accessToken: config ? config.mapbox.key : '',
    });
    const getAddress = async (long, lat) => {
        const addressResult = await geocoder.reverseLookup(long, lat);
        setAddress(addressResult);
    };
    return { getAddress, address };
};
